import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/services/supabase";

export function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // 1. 使用 Supabase 标准登录
      const { data, error: signInError } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (signInError) throw signInError;
      if (!data.user) throw new Error("登录失败");

      // 2. 验证该用户是否拥有管理员权限
      const { data: isAdmin, error: rpcError } = await supabase.rpc('is_admin', {
        p_user_id: data.user.id
      });

      if (rpcError) throw rpcError;

      if (isAdmin) {
        sessionStorage.setItem('admin_authenticated', 'true');
        navigate("/admin/dashboard");
      } else {
        // 如果不是管理员，退出登录并报错
        await supabase.auth.signOut();
        throw new Error("该账号没有管理员权限");
      }
    } catch (err: any) {
      setError(err.message || "登录失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            系统管理后台
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            请输入管理员邮箱与密码
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleLogin}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label className="sr-only">管理员邮箱</label>
              <input
                type="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="管理员邮箱"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label className="sr-only">密码</label>
              <input
                type="password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="密码"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="text-red-500 text-sm text-center bg-red-50 p-2 rounded border border-red-200">
              {error}
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 transition-colors"
            >
              {loading ? "验证中..." : "登录后台"}
            </button>
          </div>
          
          <div className="text-center mt-4">
            <button 
              type="button"
              onClick={() => navigate("/")}
              className="text-sm text-gray-500 hover:text-gray-900"
            >
              返回网站首页
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
